import PropTypes from '../../utils/propTypes';
import styles from './index.module.scss';

const { wrapper, proportions } = styles;

const VolumeStatus = ({ total, progress, unit }) => {
  const maxWidth = 98;
  const percentage = total > 0 ? Math.min(progress / total, 1) : 0;
  const width = maxWidth * percentage;

  return (
    <div className={wrapper}>
      <svg
        width="100"
        height="10"
        viewBox="0 0 100 10"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0" y="0" width={maxWidth} height="8" fill="#D9D9D9" />
        <rect x="0" y="0" width={width} height="8" fill="#FF0000" />
      </svg>
      <p className={proportions}>{`${progress}/${total} ${unit}`}</p>
    </div>
  );
};

VolumeStatus.propTypes = {
  total: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
};

export default VolumeStatus;
